import { onboardingService } from "../../../../shared/core/service/services";

/**
 * Ramène le document du serveur et l'ouvre dans un onglet. Le navigateur n'a pas de système de
 * fichiers : on passe par un blob, qu'on relâche une fois l'onglet servi.
 */
export async function openDocument(documentId: string): Promise<void> {
  const { data, contentType } = await onboardingService.getDocumentContent(documentId);
  const url = URL.createObjectURL(new Blob([data], { type: contentType || "application/octet-stream" }));

  window.open(url, "_blank", "noopener");
  // L'onglet a pris sa copie ; garder l'URL vivante ne ferait que retenir le blob en mémoire.
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
